import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Auth } from '@core/services';

export const authGuard: CanActivateFn = () => {
  const authService = inject(Auth);

  const token = authService.token;

  if (!token) {
    authService.logout();
    return false;
  }

  return true;
};
